import React, { useState } from "react";
import { ThemeToggle } from "@/components/theme-toggle";
import { LanguageToggle } from "@/components/language-toggle";
import { MonitorCog } from "lucide-react";

export function AuthStickyControls() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className=" flex flex-col gap-2 items-center fixed bottom-6 right-6 z-50">
      <div
        className={`mt-3 flex flex-col gap-2 p-2 bg-background/80 backdrop-blur-sm border border-border rounded-lg shadow-lg transition-all duration-300 ${
          isOpen
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <ThemeToggle />
        <LanguageToggle />
      </div>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 bg-background/80 backdrop-blur-sm border border-border rounded-full shadow-lg hover:bg-background/90 transition-all"
      >
        {isOpen ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        ) : (
          <MonitorCog />
        )}
      </button>
    </div>
  );
}
